import bigrams from './bigrams';
import unigrams from './unigrams';

export { bigrams, unigrams };

const ngrams = { bigrams, unigrams };

export default ngrams;
